var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckbox = function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    fill: "none",
    viewBox: "0 0 75 75"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M15.625 20.063c0-2.27 1.834-4.188 4.188-4.188h34.375c2.262 0 4.187 1.925 4.187 4.188v34.375c0 2.353-1.918 4.187-4.187 4.187H19.813c-2.361 0-4.188-1.827-4.188-4.187zM19.813 18c-1.175 0-2.063 1.025-2.063 2.063v34.375c0 1.154.907 2.062 2.063 2.062h34.375c1.037 0 2.062-.888 2.062-2.062V20.063c0-.554-.272-1.065-.635-1.428S54.741 18 54.187 18zm28.869 9.643c.078-.08.23-.147.44-.147.191 0 .382.059.525.161l.777.875.033.026c.214.171.276.599-.041.917L32.861 46.932a.9.9 0 0 1-.536.17c-.209 0-.361-.069-.44-.147l-8.397-8.494-.002-.002a.67.67 0 0 1-.22-.477c0-.148.06-.317.22-.476l.782-.781c.317-.318.745-.255.916-.042l.017.022 7.11 7.11 16.368-16.17z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckbox;